import { render, staticRenderFns } from "./BranchCheckRecordAlone.vue?vue&type=template&id=1a24ce8c&"
import script from "./BranchCheckRecordAlone.vue?vue&type=script&lang=ts&"
export * from "./BranchCheckRecordAlone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports